import React, { useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Typography,
  IconButton,
  Card,
  CardContent,
  Drawer,
  DialogContent,
  Divider,
  DialogActions,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import FormOrder from '../forms/FormOrder';
import {
  Actions,
  useDispatchProvider,
  useStateDrawerOrder,
  useStateFormOrder,
  useStateTabsOrder,
} from '../utils/StateProvider';
import ListOrderProducts from '../lists/ListOrderProducts';

const DrawerOrder = () => {
  const portalRef = useRef(null);
  const stateFormOrder = useStateFormOrder();
  const stateTabsOrder = useStateTabsOrder();
  const stateDrawerOrder = useStateDrawerOrder();
  const dispatch = useDispatchProvider();
  const handleDrawerClose = () => {
    dispatch && dispatch({ type: Actions.DrawerOrder, payload: false });
  };

  const handleChangeTab = (event, newValue) => {
    dispatch && dispatch({ type: Actions.TabsOrder, payload: newValue });
  };

  return (
    <Drawer
      open={stateDrawerOrder}
      onClose={handleDrawerClose}
      anchor={'bottom'}
      color={'background'}
      elevation={0}
      sx={{
        '& .MuiDrawer-paper': {
          height: '100dvh',
        },
      }}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDrawerClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Order details
          </Typography>
        </Toolbar>
      </AppBar>
      <AppBar
        elevation={0}
        position={'sticky'}
        color={'transparent'}
      >
        <Toolbar>
          <Tabs
            value={stateTabsOrder}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
          >
            <Tab
              label={'Information'}
              value={'form'}
              sx={{ height: 64 }}
            />
            <Tab
              label={'Products'}
              value={'products'}
              sx={{ height: 64 }}
              disabled={stateFormOrder === ''}
            />
          </Tabs>
        </Toolbar>
        <Divider />
      </AppBar>
      {stateTabsOrder === 'form' && (
        <DialogContent>
          <Card elevation={1}>
            <CardContent>
              <FormOrder portalRef={portalRef} />
            </CardContent>
          </Card>
        </DialogContent>
      )}
      {stateTabsOrder === 'products' && (
        <DialogContent sx={{ overflow: 'hidden', pb: 0 }}>
          <ListOrderProducts portalRef={portalRef} />
        </DialogContent>
      )}
      <DialogActions
        sx={{ paddingX: 3, paddingY: 2 }}
        ref={portalRef}
      />
    </Drawer>
  );
};

export default DrawerOrder;
